module.exports = __webpack_public_path__ + "static/img/5.ac2f87f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/sp/5.png
// module id = SgnX
// module chunks = 0